export default __webpack_public_path__ + "locales/si/Files.json?hash=7793a171e4372f8a75b4d8e8a7ad5b55";